var React = require('react');

function LeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m256 512c-68.378906 0-132.667969-26.628906-181.019531-74.980469-48.351563-48.351562-74.980469-112.640625-74.980469-181.019531s26.628906-132.667969 74.980469-181.019531c48.351562-48.351563 112.640625-74.980469 181.019531-74.980469s132.667969 26.628906 181.019531 74.980469c48.351563 48.351562 74.980469 112.640625 74.980469 181.019531s-26.628906 132.667969-74.980469 181.019531c-48.351562 48.351563-112.640625 74.980469-181.019531 74.980469zm0-472c-119.101562 0-216 96.898438-216 216s96.898438 216 216 216 216-96.898438 216-216-96.898438-216-216-216zm62.285156 326-110-110 110-110-28.285156-28.285156-138.285156 138.285156 138.285156 138.285156zm0 0"}));
}

LeftInline.defaultProps = {"height":"512pt","viewBox":"0 0 512 512","width":"512pt"};

module.exports = LeftInline;

LeftInline.default = LeftInline;
